
import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import { Parametro } from '../../types/Plantillas/Parametro';

// Define props for the component
interface ParametroListProps {
  parametrosIni: { [key: string]: string };
  // initialParametros: Parametro[];
  onParametrosChange: (parametrosIni: { [key: string]: string }) => void;
  onSuccesChange: () => void;
}

const ParametroList: React.FC<ParametroListProps> = ({
  parametrosIni,
  // initialParametros,
  onParametrosChange,
  onSuccesChange
}) => {
  const handleEjemploChange = (key: string, value: string) => {
    // const updatedParametros = [...initialParametros];
    // updatedParametros[index].ejemplo = value;
    const updatedParams = {
      ...parametrosIni,
      [key]: value,
    };
    onParametrosChange(updatedParams);
    onSuccesChange();
  };

  return (
    <div>
      {Object.entries(parametrosIni).map(([parametro, valor], index) => (
        <Box
          key={index}
          sx={{ display: 'flex', flexDirection: 'row', gap: 2, marginBottom: 2 }}
        >
          <Box width={'5vw'}>
            <TextField
              disabled
              value={`[${index + 1}]`}
              InputProps={{
                sx: {
                  height: '30px',
                  padding: 0,
                  fontSize: '12px',
                },
              }}
            />
          </Box>
          <TextField
            disabled
            value={parametro}
            InputProps={{
              sx: {
                height: '30px',
                padding: 0,
                fontSize: '12px',
              },
            }}
          />
          <TextField
            value={valor}
            onChange={(e) => {
                handleEjemploChange(parametro, e.target.value)
              }
            }
            onBlur={(e) => {
              handleEjemploChange(parametro, e.target.value)
            }}
            InputProps={{
              sx: {
                height: '30px',
                padding: 0,
                fontSize: '12px',
              },
            }}
          />
        </Box>
      ))}
    </div>
  );
};

export default ParametroList;